import React from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";

// Michael's number (per migrated contact info from huis-aan-de-costa-del-sol.nl)
const WHATSAPP_NUMBER = "34604134186";

const GENERIC_PREFILL = {
  nl: "Hallo Michael, ik heb een vraag over een woning aan de Costa del Sol.",
  en: "Hello Michael, I have a question about a property on the Costa del Sol.",
  de: "Hallo Michael, ich habe eine Frage zu einer Immobilie an der Costa del Sol.",
  es: "Hola Michael, tengo una consulta sobre una propiedad en la Costa del Sol.",
};

const PROPERTY_PREFILL = {
  nl: (ref) => `Hallo Michael, ik heb interesse in woning ${ref}.`,
  en: (ref) => `Hello Michael, I am interested in property ${ref}.`,
  de: (ref) => `Hallo Michael, ich interessiere mich für Objekt ${ref}.`,
  es: (ref) => `Hola Michael, estoy interesado en la propiedad ${ref}.`,
};

function getPropertyReference(pathname) {
  // Matches /aanbod/<reference> (and optional trailing slash). Decodes URL-encoded ref.
  const m = pathname.match(/^\/aanbod\/([^/?#]+)/);
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]);
  } catch {
    return m[1];
  }
}

export default function WhatsAppButton() {
  const { lang } = useLang();
  const { pathname } = useLocation();

  const reference = getPropertyReference(pathname);
  const text = reference
    ? (PROPERTY_PREFILL[lang] || PROPERTY_PREFILL.nl)(reference)
    : GENERIC_PREFILL[lang] || GENERIC_PREFILL.nl;

  const href = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(text)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp Michael Hannes"
      title={reference ? `WhatsApp · ${reference}` : "WhatsApp Michael Hannes"}
      className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-40 flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] hover:bg-[#1ebd5b] transition-transform hover:scale-105"
      style={{ boxShadow: "0 6px 20px rgba(37, 211, 102, 0.35)" }}
      data-testid="whatsapp-button"
      data-property-ref={reference || ""}
    >
      <svg
        viewBox="0 0 32 32"
        width="26"
        height="26"
        fill="#FFFFFF"
        aria-hidden="true"
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.064 0-.123-.022-.166-.057-1.207-.658-2.43-1.39-3.31-2.518-.043-.044-.07-.097-.07-.158 0-.305.918-.927.918-1.297 0-.075-.025-.158-.07-.226-.422-.604-1.06-1.665-1.456-2.21-.123-.18-.196-.292-.297-.292-.297 0-1.225.18-1.225 1.43 0 1.18.96 2.396 1.25 2.732 1.5 2.13 3.78 3.32 4.84 3.74.706.293 1.235.405 1.643.405.547 0 1.218-.16 1.612-.448.355-.26.51-.624.51-1.022 0-.27-.04-.482-.115-.61-.187-.31-.673-.46-1.347-.86l-.001-.003zm-3.111-13.205c-7.18 0-13 5.82-13 13 0 2.293.6 4.534 1.738 6.508l-1.737 6.49 6.628-1.738c1.95 1.085 4.116 1.652 6.354 1.652h.006c7.18 0 13-5.82 13-13 0-3.473-1.353-6.74-3.81-9.193-2.456-2.456-5.722-3.808-9.196-3.808l.017-.001zm0 23.83c-2.025 0-4.013-.547-5.747-1.578l-.412-.245-4.27 1.12 1.14-4.166-.27-.428c-1.135-1.807-1.737-3.896-1.737-6.043 0-6.262 5.094-11.356 11.356-11.356 3.033 0 5.882 1.182 8.025 3.327 2.143 2.146 3.32 4.998 3.317 8.03 0 6.263-5.093 11.34-11.355 11.34h-.047z"/>
      </svg>
    </a>
  );
}
